import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const formInputFn = /* @__PURE__ */ createRecipe('form-input', {
  "variant": "input",
  "size": "md"
}, [])

const formInputVariantMap = {
  "size": [
    "sm",
    "md",
    "lg",
    "xl"
  ],
  "variant": [
    "input",
    "textarea"
  ]
}

const formInputVariantKeys = Object.keys(formInputVariantMap)

export const formInput = /* @__PURE__ */ Object.assign(memo(formInputFn.recipeFn), {
  __recipe__: true,
  __name__: 'formInput',
  __getCompoundVariantCss__: formInputFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: formInputVariantKeys,
  variantMap: formInputVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, formInputVariantKeys)
  },
  getVariantProps: formInputFn.getVariantProps,
})